import React, { useState, useEffect, useCallback } from "react"

import { useApp } from "../../hooks/useApp"

export const withMap = Component => ({ name = "Map", location, selectedStore, mapStores, disableInfoWindow = false }) => {
  const {
    config: {
      services: { googleMaps },
    },
  } = useApp()

  const currentLocation = location ? location : mapStores?.[0]?.location

  const [storesData, setStoresData] = useState([])

  const handleSetInitialState = useCallback(
    mapStores => {
      return mapStores.map((store, index) => {
        return {
          ...store,
          showInfoWindow: selectedStore && selectedStore.id === store.id ? true : !selectedStore && index === 0 ? true : false,
        }
      })
    },
    [selectedStore]
  )

  const handleMarkerClick = key => {
    setStoresData(prevStoresData => {
      const index = prevStoresData.findIndex(e => e.id === key.toString())
      const newStoresData = [...prevStoresData]
      newStoresData[index].showInfoWindow = !prevStoresData[index].showInfoWindow
      return newStoresData
    })
  }

  const handleMarkerClose = key => {
    setStoresData(prevStoresData => {
      const index = prevStoresData.findIndex(e => e.id === key.toString())
      const newStoresData = [...prevStoresData]
      newStoresData[index].showInfoWindow = false
      return newStoresData
    })
  }

  useEffect(() => {
    setStoresData(handleSetInitialState(mapStores))
  }, [handleSetInitialState, mapStores])

  Component.displayName = name
  return (
    <Component
      googleMapKey={googleMaps?.apiKey}
      location={currentLocation}
      storesData={storesData}
      handleMarkerClick={handleMarkerClick}
      handleMarkerClose={handleMarkerClose}
      disableInfoWindow={disableInfoWindow}
    />
  )
}
